export default __webpack_public_path__ + "static/media/2122 utensils side.f79e31d8.png";